import { render, staticRenderFns } from "./AutoPlay.vue?vue&type=template&id=365573ab&scoped=true"
import script from "./AutoPlay.vue?vue&type=script&lang=js"
export * from "./AutoPlay.vue?vue&type=script&lang=js"
import style0 from "./AutoPlay.vue?vue&type=style&index=0&id=365573ab&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "365573ab",
  null
  
)

export default component.exports